<template>
    <div class="mask-bg">
         <div class="login-box hb-box">
          <div class="title">
             <div v-if="isWin">
                获得{{ amount }}!
             </div>
             <div v-else>
              太遗憾了
             </div>
          </div>
          <div class="prize-box">
            <img :src="prizeImg" alt="" lazy>
          </div>
          <div class="final-agine" @click="close">继续抽奖</div>
         </div>
    </div>
</template>

<script>
export default {
  props: {
    amount: {
      type: String,
      default: ''
    },
    isWin: {
      type: Boolean,
      default: false
    },
    prizeImg: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
    };
  },
  computed: {
    boxHeightRem() {
      return this.innerHeightRem;
    },
  },
  components: {
  },
  mounted() {
  },
  methods: {
    close() {
      this.$emit('close', 'showFinalModal')
    },
  },

  watch: {
  }
};
</script>

<style scoped lang="less">
.mask-bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.60);
}

.login-box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 311px;
  margin: 0 auto;
  border-radius: 8px;
  background: url(~@/assets/get.png) no-repeat center top / 100% auto;
}

.hb-box {
  display: flex;
  width: 311px;
  height: 370px;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  flex-shrink: 0;
}

.title {
  margin-top: 66px;
  color: #000;
  text-align: center;
  font-family: "PingFang SC";
  font-size: 20px;
  font-style: normal;
  line-height: normal;
}

.prize-box{
    height: 200px;
    img {
      object-fit: contain;
    }
}


.final-agine {
  width: 136px;
  height: 35px;
  line-height: 31px;
  margin-top: 10px;
  flex-shrink: 0;
  border-radius: 8px;
  background: linear-gradient(90.89deg, #FD8943 1.2%, #FB4331 99.68%);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);

  text-align: center;
  color: #fff;
  font-family: "PingFang SC";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
}
</style>